import { MAXIMUM_TICKET_AMOUNT } from '@/lib/offers/constants';

export function getTicketInputNextValue(proposedValue: string, maxValue = MAXIMUM_TICKET_AMOUNT): number | null {
  let nextValue = Number(proposedValue);
  if (Number.isNaN(nextValue) || !Number.isInteger(nextValue)) return null;
  if (nextValue < 0) return null;
  if (nextValue > maxValue) nextValue = maxValue;
  if (nextValue < 0) nextValue = 0;
  return nextValue;
}
